// customer-details-dialog.component.ts
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import * as moment from 'moment';

@Component({
  selector: 'app-customer-details-dialog',
  templateUrl: './customer-details-dialog.component.html',
  styleUrls: ['./customer-details-dialog.component.scss']
})
export class CustomerDetailsDialogComponent implements OnInit {

  selectedTab: number = 0;
  ordersDisplayedColumns: string[] = ['orderId', 'orderDate', 'totalAmount', 'products'];
  repairsDisplayedColumns: string[] = ['repairId', 'scheduleDate', 'propertyAddress', 'contactPhone', 'additionalInfo'];

  // Create MatTableDataSource instances
  ordersDataSource: MatTableDataSource<any>;
  repairsDataSource: MatTableDataSource<any>;

  constructor(
    public dialogRef: MatDialogRef<CustomerDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      customer: any,
      orders: any[],
      repairs: any[],
      totalQuotes: number,
      totalRepairs: number
    }
  ) {
    // Initialize data sources
    this.ordersDataSource = new MatTableDataSource(this.data.orders || []);
    this.repairsDataSource = new MatTableDataSource(this.data.repairs || []);

    console.log("this.ordersDataSource",this.ordersDataSource);
  }

  ngOnInit() {
    console.log('Customer Details Dialog Data:', this.data);
  }

  onCloseDialog(): void {
    this.dialogRef.close();
  }

  formatDate(date: string): string {
    if (!date) return '';
    return moment(date).format('MM/DD/YYYY hh:mm A');
  }

  formatCurrency(amount: number): string {
    if (!amount && amount !== 0) return '$0.00';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  }

  getProductNames(products: any[]): string {
    if (!products || products.length === 0) return 'No products';
    
    var productNames = [];
    for (var i = 0; i < products.length; i++) {
      if (products[i] && products[i].name) {
        productNames.push(products[i].name);
      } else {
        productNames.push('Unknown Product');
      }
    }
    return productNames.join(', ');
  }

  getOrderStatusColor(status: string): string {
    if (!status) return '#757575';
    
    var statusLower = status.toLowerCase();
    switch (statusLower) {
      case 'completed': return '#4caf50';
      case 'processing': return '#ff9800';
      case 'pending': return '#2196f3';
      case 'cancelled': return '#f44336';
      default: return '#757575';
    }
  }

  expandOrderDetails(order: any) {
    if (order) {
      order.expanded = !order.expanded;
    }
  }

  expandRepairDetails(repair: any) {
    if (repair) {
      repair.expanded = !repair.expanded;
    }
  }

  getTotalOrderValue(): number {
    if (!this.data.orders || this.data.orders.length === 0) return 0;
    
    var total = 0;
    for (var i = 0; i < this.data.orders.length; i++) {
      if (this.data.orders[i] && this.data.orders[i].totalAmount) {
        total += this.data.orders[i].totalAmount;
      }
    }
    return total;
  }

  exportCustomerData() {
    var customerData = {
      customer: this.data.customer,
      summary: {
        totalQuotes: this.data.totalQuotes,
        totalRepairs: this.data.totalRepairs,
        totalOrderValue: this.getTotalOrderValue()
      },
      orders: this.data.orders,
      repairs: this.data.repairs
    };

    var dataStr = JSON.stringify(customerData, null, 2);
    var dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
    
    var customerName = this.data.customer.customerName || 'customer';
    var cleanName = customerName.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_]/g, '');
    var exportFileDefaultName = 'customer_' + cleanName + '_details.json';
    
    var linkElement = document.createElement('a');
    linkElement.setAttribute('href', dataUri);
    linkElement.setAttribute('download', exportFileDefaultName);
    linkElement.style.display = 'none';
    document.body.appendChild(linkElement);
    linkElement.click();
    document.body.removeChild(linkElement);
  }

  getCustomerPhone(): string {
    if (this.data.customer && this.data.customer.phone) {
      return this.data.customer.phone;
    }
    return 'No phone number';
  }

  getOrderProducts(order: any): any[] {
    if (order && order.products && Array.isArray(order.products)) {
      return order.products;
    }
    return [];
  }

  getRepairInfo(repair: any): string {
    if (!repair) return 'No additional information';
    if (repair.additionalInfo) {
      return repair.additionalInfo;
    }
    return 'No additional information';
  }

  getOrderBillingInfo(order: any): any {
    if (order && order.billing) {
      return order.billing;
    }
    return {};
  }

  isOrderExpanded(order: any): boolean {
    return order && order.expanded === true;
  }

  isRepairExpanded(repair: any): boolean {
    return repair && repair.expanded === true;
  }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/crm-flow/customer-details-dialog/customer-details-dialog.component.ts